import styled, { css } from 'styled-components';

export const Wrapper = styled.footer`
  position: absolute;
  left: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* 100vw는 세로 스크롤바 폭까지 포함해 가로 스크롤을 유발한다.
     absolute + LayoutContainer(width:100%) 기준이라 100%면 스크롤바 없이 꽉 찬다. */
  width: 100%;
  min-width: ${({ theme }) => theme.WIDTH.PC_LAYOUT};
  height: fit-content;
  border-top: 1px solid ${({ theme }) => theme.COLOR.GREY_05};
  background-color: ${({ theme }) => theme.COLOR.WHITE};
`;

export const InnerWrapper = styled.div<{
  bottom?: boolean;
  isMobile?: boolean;
}>`
  display: flex;
  justify-content: ${({ bottom }) => (bottom ? 'flex-start' : 'center')};
  width: ${({ isMobile, theme }) =>
    isMobile ? theme.WIDTH.MOBILE_LAYOUT : theme.WIDTH.PC_LAYOUT};
  max-width: ${({ isMobile, theme }) =>
    isMobile ? theme.WIDTH.MOBILE_LAYOUT : theme.WIDTH.PC_LAYOUT};

  ${({ isMobile, bottom }) =>
    isMobile &&
    css`
      justify-content: ${bottom && 'center'};
    `}
`;

export const CsSectionWrapper = styled.div<{ isMobile?: boolean }>`
  padding: ${({ isMobile }) => isMobile && '30px 0'};
`;

export const CompanyInfoSectionWrapper = styled.div<{ isOrcar?: boolean }>`
  margin-top: 26px;
  ${({ isOrcar }) => isOrcar && '#8E8E8E'};
`;

export const CompanyInfoInnerWrapper = styled.div<{ isMobile?: boolean }>`
  display: flex;
  align-items: ${({ isMobile }) => isMobile && 'flex-end'};
`;

export const TopSection = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  padding: 38px 0 30px;
`;

export const BottomSection = styled.div<{ isMobile?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  padding: 24px 20px;
  margin-top: ${({ isMobile }) => isMobile && '30px'};
  border-top: 1px solid ${({ theme }) => theme.COLOR.GREY_05};
`;

/** 고시제 대여사업자 표기 — 푸터 하단에 크고 진하게 노출 */
export const RentalOperator = styled.p`
  ${({ theme }) => theme.FONT.H4};
  font-weight: 800;
  color: ${({ theme }) => theme.COLOR.GREY_01};
  text-align: center;
  line-height: 1.5;
  word-break: keep-all;
`;

export const LeftSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
`;

export const RightSection = styled.div`
  position: absolute;
  right: 0;
  display: flex;
  width: 50%;
  padding-left: 70px;
`;

export const NavLinkWrapper = styled.div<{ isMobile?: boolean }>`
  display: flex;
  flex-direction: ${({ isMobile }) => isMobile && 'column'};
  justify-content: flex-start;
  margin-top: ${({ isMobile }) => isMobile && '30px'};
  gap: ${({ isMobile }) => (isMobile ? '8px' : '20px')};
`;

export const NavLink = styled.a<{ sub?: boolean; isMobile?: boolean }>`
  font-family: 'GmarketSansMedium';
  height: fit-content;
  ${({ isMobile, theme }) => (isMobile ? theme.FONT.B3 : theme.FONT.B1)};
  line-height: 27px;
  font-weight: 400;
  color: ${({ theme }) => theme.COLOR.GREY_01};
  cursor: pointer;
  white-space: nowrap;

  ${({ isMobile, sub, theme }) =>
    sub &&
    css`
      margin-left: ${isMobile ? '10px' : '20px'};
      ${isMobile ? theme.FONT.B3 : theme.FONT.B2};
      font-weight: 600;
      color: ${theme.COLOR.GREY_02};
    `}
`;

export const InfoContent = styled.p<{
  margin?: string;
  color?: string;
  font?: Record<string, string>;
  isMobile?: boolean;
  isOrcar?: boolean;
}>`
  margin: ${({ margin }) => margin};
  ${({ font, theme, isMobile }) =>
    font ? font : isMobile ? theme.FONT.B3 : theme.FONT.B2};
  font-weight: ${({ font, theme }) => (font ? font : theme.FONT.B2 && 500)};
  color: ${({ color, theme }) => (color ? color : theme.COLOR.GREY_02)};

  ${({ isOrcar }) =>
    isOrcar &&
    css`
      color: #8e8e8e;
      font-weight: 300;
    `}
`;

export const InfoLink = styled.a<{ icon?: boolean }>`
  ${({ theme }) => theme.FONT.B2};
  color: ${({ theme }) => theme.COLOR.GREY_01};
  cursor: pointer;

  ${({ icon }) =>
    icon &&
    css`
      &::after {
        margin-left: 10px;
        background: url('/ic_arrow_right.svg') no-repeat 0 0;
        content: '';
        display: inline-block;
        width: 6px;
        height: 10px;
      }
    `}
`;

export const NoticeSection = styled.div`
  width: 208px;
  padding: 0 10px 10px;
`;

export const NoticeTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 13px;
`;

export const ListWrapper = styled.div`
  display: grid;
  grid-gap: 10px;
`;

/** 푸터 상단 로고 행 — 제주로렌트카 로고 옆에 갤럭시렌트카 로고를 나란히 */
export const FooterLogos = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;
